<div class="login-page">
  <div class="login-welcome-panel">
    <div class="welcome-pattern"></div>
    <div class="welcome-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
    </div>
    <div class="welcome-content">
      <div class="welcome-logo">
        <div class="logo-truck-container">🚚</div>
      </div>

      <!-- Route animation -->
      <div class="route-animation">
        <svg class="route-svg" viewBox="0 0 300 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path class="route-path"
            d="M 20 24 Q 80 8 150 24 Q 220 40 280 24"
            stroke="rgba(255,255,255,0.6)" stroke-width="2.5"
            stroke-dasharray="300" stroke-linecap="round" fill="none"/>
          <circle class="route-dot-start" cx="20" cy="24" r="5" fill="#22c55e"/>
          <circle class="route-dot-end" cx="280" cy="24" r="5" fill="#f97316"/>
        </svg>
        <div class="route-truck">🚛</div>
      </div>

      <h1 class="welcome-title">Dematral Express</h1>
      <p class="welcome-subtitle">Plateforme de gestion de livraisons</p>

      <!-- Mini stats -->
      <div class="welcome-stats">
        <div class="stat-item">
          <span class="stat-value">360°</span>
          <span class="stat-label">Suivi</span>
        </div>
        <div class="stat-item">
          <span class="stat-value">24/7</span>
          <span class="stat-label">Disponible</span>
        </div>
        <div class="stat-item">
          <span class="stat-value">100%</span>
          <span class="stat-label">Fiable</span>
        </div>
      </div>

      <div class="welcome-features">
        <div class="feature-item">
          <div class="feature-icon-wrapper">
            <span class="feature-icon">📦</span>
          </div>
          <span class="feature-text">Gestion complète des commandes</span>
        </div>
        <div class="feature-item">
          <div class="feature-icon-wrapper">
            <span class="feature-icon">🗺️</span>
          </div>
          <span class="feature-text">Suivi live des livraisons</span>
        </div>
        <div class="feature-item">
          <div class="feature-icon-wrapper">
            <span class="feature-icon">📊</span>
          </div>
          <span class="feature-text">Tableaux de bord & rapports</span>
        </div>
        <div class="feature-item">
          <div class="feature-icon-wrapper">
            <span class="feature-icon">💰</span>
          </div>
          <span class="feature-text">Finance & facturation intégrées</span>
        </div>
      </div>
    </div>
  </div>

  <div class="login-form-panel">
    <div class="form-container">
      <div class="form-header">
        <div class="form-logo">
          <span class="logo-dot"></span>
          <!-- <span class="logo-text">Dematral</span> -->
          <img src="../../../../assets/img/logo/logo.png" alt="logo not found" width="300px" height="auto">
        </div>

      </div>

      <div class="form-title-section">
        <!--<a href="javascript:void(0)" class="create-account-link" (click)="$event.preventDefault()" title="Fonctionnalité à venir">
          <span>Créer un compte</span>
          <span class="arrow">→</span>
        </a>-->
        <h2 class="form-title">Connexion</h2>
        <!-- <p class="form-subtitle">Connectez-vous pour continuer</p> -->
      </div>

      <div class="error-message" *ngIf="messageErreur">
        <span class="error-icon">!</span>
        <span>{{ messageErreur }}</span>
      </div>

      <form [formGroup]="formulaireConnexion" (ngSubmit)="connexion()" class="login-form">
        <div class="form-group">
          <label class="form-label">Identifiant</label>
          <div class="input-wrapper">
            <input class="form-input" type="text" placeholder="Votre identifiant" formControlName="username">
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Mot de passe</label>
          <div class="password-input-wrapper">
            <input class="form-input password-input" [type]="masquerMotDePasse ? 'password' : 'text'" placeholder="••••••••" formControlName="password">
            <button
              type="button"
              (click)="masquerMotDePasse = !masquerMotDePasse"
              class="password-toggle-btn"
              [attr.aria-label]="masquerMotDePasse ? 'Afficher le mot de passe' : 'Masquer le mot de passe'">
              <mat-icon>{{ masquerMotDePasse ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
          </div>
        </div>

        <div class="form-options">
          <label class="checkbox-label">
            <input type="checkbox">
            <span>Se souvenir de moi</span>
          </label>
          <a href="javascript:void(0)" class="link" (click)="$event.preventDefault()" title="Fonctionnalité à venir">Mot de passe oublié ?</a>
        </div>

        <button type="submit" class="btn btn-primary" [disabled]="chargement">
          <span *ngIf="chargement" class="loading-spinner"></span>
          <span>{{ chargement ? 'Connexion...' : 'Se connecter' }}</span>
          <span class="btn-arrow" *ngIf="!chargement">→</span>
        </button>
      </form>

      <div class="suivi-lien" style="text-align:center;margin-top:16px;">
        <a routerLink="/suivi-public" class="link">Suivre une commande (n° de commande ou de suivi)</a>
      </div>

      <div class="form-footer">
        <p>Vous n'avez pas encore de compte ? <a href="javascript:void(0)" class="link link-bold" (click)="$event.preventDefault()" title="Fonctionnalité à venir">Créer un compte</a></p>
      </div>

      <div class="login-dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</div>